<template>  
  <v-container fluid grid-list-lg class="ma-0 pa-0">
    <v-card flat>
      <v-card-text>
        <v-layout row>
          <v-flex xs12 md12>
            <v-autocomplete outlined dense hide-no-data hide-details
              v-model="fm.nomors"
              label="Berdasarkan Pertanyaan"
              :items="pertanyaans"
              item-text="name"        
              item-value="id"      
              multiple
              :loading="pertanyaanLoading"
              autocomplete="off"
            />
          </v-flex>          
        </v-layout>        
      </v-card-text>
      <v-divider />
      <v-card-text>
        <v-layout row>
          <v-flex xs12 md6 v-for="(item, i) in charts" :key="i">
            <v-card>  
              <v-card-text class="px-2">{{item.question}}</v-card-text> 
              <v-divider/>           
              <echart v-if="!item.loading" :option="item.chartOption" :height="item.height+'px'" />
              <template v-else>
                <v-skeleton-loader                
                  style="width:100%"
                  type="card, article"
                ></v-skeleton-loader>
              </template>
            </v-card>               
          </v-flex>          
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import Echart from '@/app/components/other/echart';
import { debounce } from 'lodash'
import Model from '@/app/models/Report'
const  model = new Model()

export default {
  components:{Echart},
  props:{
    jilid : {type:Object}
  },
  data () {
    return {
      fm:{ nomors:[] },    
      charts : [],
      pertanyaans  : [], pertanyaanLoading  : false, 
      loading : false,
      chartOption :  {
        title: {
            text: 'Demografi (%)',
            subtext: 'Sebaran Responden'
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter: "{b} : {c}%"    
        },
        legend: {
            data: ['responden']
        },
        toolbox: {
            show : true,
            x: 'right',
            feature : {
                mark : {show: true},
                //dataView : {show: true, readOnly: false},
                //restore : {show: true},
                saveAsImage : {show: true, title:'Pict'}
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01]
        },
        yAxis: {
            type: 'category',
            data: ['巴西','印尼','美国','印度','中国','世界人口(万)']
        },
        series: [
            {
                name: 'responden',
                type: 'bar',
                label: {
                  normal: {
                    show: true,
                    position: 'right',
                    formatter: "{c}%"    
                  },                  
                },
                data: [18203, 23489, 29034, 104970, 131744, 630230]
            },  
        ]
      },
    }
  },
  computed:{
        
  },
  watch:{
    'fm.nomors'(newIds) {
      if(Array.isArray(this.jilid.quetionnaires)){
        this.charts = [];
        newIds.forEach(id=>{        
          let q = this.jilid.quetionnaires.find(x=>x.no==id);
          if(q){
            this.charts.push({no:q.no, question:q.no+'. '+q.question, loading:true, option:q.option, chartOption:{}, height:390});        
          }          
        })
      }        
    },
    'fm': {
      handler : debounce(function () {      
        this.readItems()
      }, 400), 
      deep:true,
    },    
  },  
  mounted() {
    this.loading = true;
    this.init();
  },
  methods: {
    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    init(){      
      if(Array.isArray(this.jilid.quetionnaires)){
        let no = 0;
        this.jilid.quetionnaires.forEach(q=>{
          if(q.type == 1){
            this.pertanyaans.push({id:q.no, name:q.no+'. '+q.question, loading:true,option:{}});
            if(no <4){
              this.fm.nomors.push(q.no);
            }          
            no++;
          }
        })
      }
    },

    readItems () {
      if(Array.isArray(this.charts)){
        this.charts.forEach(c=>{
          c.loading = true;    
          const params = {        
            jilid_id: this.jilid.id,        
            no: c.no,
            expand:'quetionnaires'
          }

          model.demografi(params).then(data => {            
            if(Array.isArray(data) && Array.isArray(c.option)){
              c.height = data.length*45 > 390 ? data.length*45 : 390;
              c.chartOption = JSON.parse(JSON.stringify(this.chartOption));
              c.chartOption.yAxis.data = [];
              c.chartOption.series[0].data = []; 
              //c.chartOption.title.subtext = c.question;             
              let color = this.$color();              
              c.chartOption.series[0].itemStyle = {color:color};
              let total = 0;              
              data.forEach(item=>{total += parseInt(item.people);});              
              data.forEach(item=>{                
                let opt = c.option.find(x=>x.id==item.answer);
                if(opt){
                  c.chartOption.yAxis.data.push(opt.value+"\n["+item.people+"]");
                  c.chartOption.series[0].data.push(parseFloat(parseInt(item.people)/total*100).toFixed(2));                  
                } else {
                  c.chartOption.yAxis.data.push("-"+"\n["+item.people+"]");
                  c.chartOption.series[0].data.push(parseFloat(parseInt(item.people)/total*100).toFixed(2));
                }         
              });
            }
            c.loading = false
          })
        })
      }            
    },      
  },  
}
</script>